var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation"},[_c('ContentContainer',[_c('div',{staticClass:"navigation__sections"},_vm._l((_vm.sections),function(ref){
var title = ref.title;
var description = ref.description;
var link = ref.link;
return _c('Section',_vm._b({key:title},'Section',{ title: title, description: description, link: link },false))}),1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }